<script>
	// import InvoiceAdd from '../cart/InvoiceAdd.svelte'
	import {onMount} from 'svelte'
	import {execQuery,execMutation,execCheckStock,execRawMutation} from '../csql.js'
	import { usuario } from '../store.js';


	export let item = {}
	export let visible = false
	export let cart_handler = () => console.log("Unhandled function")

	let loading=false

	let target_subproducto = ''
	let target_size = ''
	let cantidad = 1


	let rs = []
	let modelos_ds = []
	
	let invoiceH = {}
	let theCartId = 0
	let estado = 'ABIERTO'

	let disableClick = false

	const getData = async() => {
		loading = true 
		let query = `select * from stock where status=1 and idproducto=${item.id} and qtty>qttysold order by size desc`
		const data = await execQuery({query})
		loading= false
		rs = data.data[0] || []
		modelos_ds = rs.map( v => v.subproducto).filter( (v,i,a) => a.indexOf(v) === i)
		target_subproducto = modelos_ds[0]
		set_size()
	}

	let talles_ds = []

	function set_size(){
		let s = rs.filter( v => (v.subproducto===target_subproducto && (v.qtty-v.qttysold>0))) 
		target_size = s[0].size
		cantidad = 1
		talles_ds = s
	}

	function add_to_cart(){
		let prd_detail = agregar()
		dispatch('insert',{prd_detail})
	}

	function comprar(){
		let prd_detail = agregar()
		//visible=false
		dispatch('comprar',{prd_detail})
	}

	async function getCurrentCart(){
		loading = true 
		let query = `select * from invoicesh where (estado="ABIERTO" or estado="ACEPTADO" ) and usuario='${$usuario.email}' order by id desc limit 1`
		const data = await execQuery({query})
		loading= false
		return data.data[0][0] || {}
	}

	async function createCart(){
		let newInvoice = {
			"usuario": $usuario.email || '',
			"nombre": $usuario.nombre || '' ,
			"apellido": $usuario.apellido || '',
			"cuit": $usuario.cuit || '',
			"domicilio": $usuario.domicilio || '',
			"ciudad": $usuario.ciudad || '',
			"provincia": $usuario.provincia || '',
			"codpostal": $usuario.codpostal || '',
			"telefono": $usuario.telefono || '',
			"transporte": '',
			"estado": 'ABIERTO',
			"observacion": $usuario.observ || '',
			"metodopago": '',
			"mpid": '',
			"mpstatus": '',
			"tipo": $usuario.tipo || 'MINO',
		}
		loading = true
		let data = {
			tabname: 'invoicesh', 
			mutation: 'insert',
			mutationId: 'id',
			params: newInvoice
		}
		const res = await execMutation(data)
		loading = false
		if(res && res.success==="OK"){
			return (res.data[0] || 0)
		}else{
			return 0
			alert("ERROR, no se realizo actualizacion!!!")
		}
	}

	async function agregar(){
		disableClick = true
		let qtty = parseInt(cantidad) || 0 
		if(qtty<1) return
		let newItem = {
			"idinvoiceh" : theCartId,
			"idproducto" : item.id,
			"producto" : item.nombre,
			"imagenes" : item.imagenes,
			"importe0" : item.importe0.toFixed(2),
			"importe1" : item.importe1.toFixed(2),
			"importe2" : item.importe2.toFixed(2),
			"subtotal0" : (item.importe0 * qtty).toFixed(2),
			"subtotal1" : (item.importe1 * qtty).toFixed(2),
			"subtotal2" : (item.importe2 * qtty).toFixed(2),
			"cantidad" : qtty,
			"subproducto": target_subproducto,
			"size": target_size,
			"marca": estado==='ACEPTADO' ? 1 : 0,
			"borrado" : 0,
		}

		const stock = await execCheckStock(newItem)

		//console.log(newItem)
		
		if(stock.dispo>=qtty){

			const duplicados = await borrar_duplicados(newItem)
	
			loading = true

			let data = {
				tabname: 'invoicesd', 
				mutation: (newItem && newItem.id && newItem.id>0) ? 'update' : 'insert',
				mutationId: 'id',
				params: newItem
			}
			const res = await execMutation(data)
			if(res && res.success==="OK"){
				loading = false
				setTimeout(() => { visible=false }, 1500);
				cart_handler({goto:'cartview',cartid:theCartId})
				disableClick = false
			}else{
				alert("ERROR, no se realizo actualizacion!!!")
				loading = false
				cart_handler({goto:'cartview',cartid:theCartId})
				disableClick = false
			}
		}else{
			alert("Stock INSUFICIENTE!")
			cart_handler({goto:'cartview',cartid:theCartId})
		}
	}


	async function borrar_duplicados(nuevo){
 		loading = true
		let stmt = `delete from invoicesd 
						where idinvoiceh=${nuevo.idinvoiceh} and idproducto=${nuevo.idproducto} and 
						subproducto="${nuevo.subproducto}" and size="${nuevo.size}"`
		const res = await execRawMutation(stmt)
		loading = false
		if(res && res.success==="OK"){
			console.log(res)
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
		return true
 	}


	onMount( async () => {
 		invoiceH = await getCurrentCart()
 		if(!invoiceH.id){
 			theCartId = await createCart()
 		}else{
 			theCartId = invoiceH.id
 			estado = invoiceH.estado
 		}
		await getData()
	})

	$: qtty_disponible = rs.filter(v => (v.subproducto===target_subproducto && v.size===target_size)).reduce( (a,b) => a+(b.qtty-b.qttysold),0)
	$: disabled = !Number.isInteger(parseInt(cantidad)) || parseInt(cantidad)<1 || parseInt(cantidad)>qtty_disponible

</script>

<div style="position:relative;top:0px;">

	<div class="container" style="min-width:360px;" xstyle="height:500px;overflow:auto;padding:0px 4px;">
		<div class="row">
			<div class="col-sm-12">
				<h4>{item.nombre}</h4>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12" style="xtext-align: center;">Elija Modelo/Color</div>
			
			<div class="col-sm-9">
				<!-- svelte-ignore a11y-no-onchange -->
				<select size="6" class="border w-48 w-full" bind:value={target_subproducto} on:change={()=>set_size()}> 
					{#each modelos_ds as prd, index}
						<!-- <option value="{prd}" class="">{prd} -  ({rs.filter(v => v.subproducto===prd).reduce( (a,b) => a+(b.qtty-b.qttysold),0)})</option>	 -->
						<option value="{prd}">{prd}</option>	
					{/each}
				</select>
				
			</div>
			<div class="col-sm-12" style="xtext-align: center;">Elija Talle</div>
			<div class="col-sm-9">
				<select size="6" class="border w-48 w-full"  bind:value={target_size}>
					{#each talles_ds as prd, index}
						<!-- <option value="{prd.size}" class="text-right">
							{prd.size} -  ({rs.filter(v => (v.subproducto===target_subproducto && v.size===prd.size)).reduce( (a,b) => a+(b.qtty-b.qttysold),0)})
						</option> -->
						<option value="{prd.size}">{prd.size}</option>	
					{/each}
				</select>
				
			</div>
		</div>

		<div class="row" style="padding:10px;">
			<div class="col-sm-3">Modelo/Color:</div>
			<div class="col-sm-9"><b>{target_subproducto}</b></div>
			<div class="col-sm-3">Talle</div>
			<!-- <div class="col-sm-9"><b>{target_size}&nbsp;</b><i>({qtty_disponible} Disponible{qtty_disponible>1?'s':''})</i></div> -->
			<div class="col-sm-9"><b>{target_size}&nbsp;</b></div>
		
			<div class="col-sm-3" style="display:flex;flex-direction: column;justify-content: center;"> Cantidad</div>
			<div class="col-sm-9">
				<input size=3 bind:value={cantidad} style="padding:2px 10px;margin-left:0;text-align:center;">
			</div>
			<div class="col-sm-3">Precio x Und.</div>
			<div class="col-sm-9">
				{#if ($usuario.tipo==="MAYO" || $usuario.tipo==="ADMIN")}
					<span>$ { (item.importe0||0).toFixed(2) } (May.)</span>
				{/if}
				{#if ($usuario.tipo==="MINO" || $usuario.tipo==="ADMIN")}
					<span>$ { (item.importe1||0).toFixed(2) } (Min.)</span>
				{/if}
			</div>
			<div class="col-sm-3">Subtotal</div>
			<div class="col-sm-9">
				{#if ($usuario.tipo==="MAYO" || $usuario.tipo==="ADMIN")}
					<span>$ {(parseInt(cantidad) * item.importe0).toFixed(2)}</span>
				{/if}
				{#if ($usuario.tipo==="MINO" || $usuario.tipo==="ADMIN")}
					<span>$ {(parseInt(cantidad) * item.importe1).toFixed(2)}</span>
				{/if}

			</div>
		</div>

		<div class="row" style="text-align:right;">
			<div class="col-sm-5 col-sm-offset-1">
				<button class="w-full large" on:click={agregar} disabled="{disabled||disableClick}">
					<i class="fas fa-cart-plus"></i>{disabled?'STOCK INSUFICIENTE':'Agregar al Carrito'}
				</button>
			</div>
			<div class="col-sm-1 col-sm-offset-1">
				<button class="secondary large" on:click={cart_handler({ goto:'catalogo' })}>&Cross;</button>
			</div>
		</div>
	</div>

</div>

